export enum ContentType {
	PAGE = 'page',
	BLOG = 'blogpost',
	WHITEBOARD = 'whiteboard',
	DATABASE = 'database',
}
